"use client";

import { useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
 import { useLanguage } from "../../src/lang/langcontext/LanguageContext";
export default function SessionTimeout() {
  const [, , removeCookie] = useCookies(["userId"]);
const { toggleLanguage } = useLanguage();
  const hasLoggedOut = useRef(false);
  const inactivityTimer = useRef(null);

  const INACTIVITY_TIME = 15 * 60 * 1000; // 15 minutes

  const logout = () => {
    if (hasLoggedOut.current) return;

    hasLoggedOut.current = true;

    alert("Your session has expired due to inactivity.");

    localStorage.removeItem("Token");
    removeCookie("userId", { path: "/" });

      toggleLanguage("en");
    window.location.replace("/");
  };

  const resetTimer = () => {
    if (hasLoggedOut.current) return;

    clearTimeout(inactivityTimer.current);

    inactivityTimer.current = setTimeout(() => {
      logout();
    }, INACTIVITY_TIME);
  };

  useEffect(() => {
    const token = localStorage.getItem("Token");

    // Don't start timer if user is not logged in
    if (!token) return;

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    events.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer();

    return () => {
      clearTimeout(inactivityTimer.current);

      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, []);

  return null;
}